import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useArticleStoryGet = (contentId) => {
  let resource = `${API_BASE_URL}/api/v2/articlestory/`;
  const params = { content_id: contentId, include_article_levels: true };
  const queryString = new URLSearchParams(params).toString();
  resource = `${resource}?${queryString}`;
  return useRestQuery(resource, { skip: !contentId });
};

export default useArticleStoryGet;
